module.exports = __webpack_public_path__ + "img/c9h-architect.b2a72e9b.png";